/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { LocationAltIcon as icon } from '../../components/Icons';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes } = metadata;

const settings = {
	title: __( 'Map' ),
	description: __( 'Gutenify map.' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'map' ),
		__( 'google' ),
		__( 'google map' ),
	],
	example: {
		attributes: {
		},
	},
	attributes,
	edit,
	save,
	supports: {
		html: false,
		align: [ 'wide', 'full' ],
	},
};

export { name, category, settings };
